var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, Textarea } from 'shared/components/ui';
import { useFormContext, } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import get from 'lodash/get';
import { useFieldContext } from 'shared/components';
import { MultiLineReadOnly } from './MultiLineReadOnly';
import { noneEntered } from 'constants/strings';
var FormTextarea = function (_a) {
    var name = _a.name, register = _a.register, rules = _a.rules, errors = _a.errors, displayErrors = _a.displayErrors, props = __rest(_a, ["name", "register", "rules", "errors", "displayErrors"]);
    // If the name is in a FieldArray, it will be 'fields.index.fieldName' and errors[name] won't return anything, so we are using lodash get
    var errorMessages = get(errors, name);
    var hasError = !!(errors && errorMessages);
    var fieldContext = useFieldContext();
    var formContext = useFormContext();
    if (fieldContext && fieldContext.readOnly && formContext)
        return (_jsx(MultiLineReadOnly, { "data-testid": props['data-testid'] ? "".concat(props['data-testid'], "-readonly") : '', text: formContext.getValues(name) || noneEntered }));
    return (_jsxs(Box, __assign({ w: "100%" }, { children: [_jsx(Textarea, __assign({ resize: 'vertical' }, (register && register(name, rules)), (displayErrors && hasError && { isInvalid: true }), props)), displayErrors && (_jsx(ErrorMessage, { errors: errors, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                name: name, render: function (_a) {
                    var message = _a.message;
                    return (_jsx(Box, { children: _jsx(Text, __assign({ "data-testid": "errors-".concat(name), color: "red.500", fontWeight: "semibold" }, { children: message })) }));
                } }))] })));
};
export { FormTextarea };
